<template>
  <Dropdown
    v-model="open"
    class="project-style"
    :class="`project-style_${position}`"
    trigger-class="project-style-toggle"
  >
    <template #trigger>
      <Button :rewrite-color="activeColor">{{ $t('Click to change color') }}</Button>
    </template>

    <template v-if="open && !onlyView" #default="slotProps">
      <ColorEmojiPicker
        :is-color="isColor"
        :is-emoji="isEmoji"
        :picked-color="activeColor"
        @color="(clr) => pickColor(clr, slotProps.close)"
        @emoji="pickEmoji"
      />
    </template>
  </Dropdown>
</template>

<script>
  import factory from '@/utils/api/factory';
  import { IuiDropdown as Dropdown } from 'industrial-ui-vue';
  import { DEFAULT_COLOR, DEFAULT_EMOJI } from '@/utils/constants/common';
  import ColorEmojiPicker from './Pickers';
  import Button from '@/components/ui-v2/Button';

  export default {
    name: 'ProjectColorDropdown',
    components: {
      Button,
      Dropdown,
      ColorEmojiPicker,
    },
    props: {
      color: String,
      emoji: String,
      projectId: [String, Number],
      noChanges: Boolean,
      onlyView: {
        type: Boolean,
        default: false,
      },
      withButton: {
        type: Boolean,
        default: false,
      },
      position: {
        type: String,
        default: 'left',
      },
    },
    data() {
      return {
        open: false,
        activeColor: this.color || DEFAULT_COLOR,
        activeEmoji: this.emoji || DEFAULT_EMOJI,
      };
    },
    computed: {
      isColor() {
        return this.activeColor !== DEFAULT_COLOR;
      },
      isEmoji() {
        return this.activeEmoji !== DEFAULT_EMOJI;
      },
    },
    methods: {
      async pickEmoji(emoji) {
        const emji = emoji ? emoji.native : DEFAULT_EMOJI;
        if (this.noChanges) {
          this.$emit('emoji', emji);
          this.activeEmoji = emji;
          return;
        }

        try {
          await factory('projects').patchInPath(this.projectId || this.$route.params.id, {
            emoji: emji,
          });
          this.activeEmoji = emji;
        } catch (e) {
          console.error(e); // eslint-disable-line
        }
      },
      async pickColor(color, close = null) {
        const clr = color ? color : DEFAULT_COLOR;
        if (this.noChanges) {
          this.$emit('color', color);
          this.activeColor = clr;
          close?.();
          return;
        }

        try {
          await factory('projects').patchInPath(this.projectId || this.$route.params.id, {
            color: clr,
          });
          this.activeColor = clr;
          this.$emit('update');
          close?.();
        } catch (e) {
          console.error(e); // eslint-disable-line
        }
      },
    },
  };
</script>
